module.exports = __webpack_public_path__ + "static/media/light-tag-content.b5c82b48.svg";